import * as Lucide from "lucide-react";
import { PROCESS_STEPS } from "@/lib/data";

const ProcessSteps = () => {
  return (
    <section className="py-24 lg:py-32 bg-white" data-testid="process-steps-section">
      <div className="container-tm">
        <div className="max-w-3xl mb-16">
          <span className="overline">Comment ça marche</span>
          <h2 className="mt-5 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Démarrage en
            <span className="italic text-gold"> 4 étapes simples</span>.
          </h2>
          <p className="mt-6 font-sans text-base md:text-lg text-ink/65 leading-relaxed max-w-2xl">
            Une mise en route fluide, sans paperasse. Nous nous occupons de tout, vous validez chaque étape.
          </p>
        </div>

        <div className="relative grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-5">
          {/* Decorative connecting line */}
          <div className="hidden lg:block absolute top-12 left-[12%] right-[12%] h-px border-t border-dashed border-gold/30 pointer-events-none" />

          {PROCESS_STEPS.map((step, i) => {
            const Icon = Lucide[step.icon] || Lucide.Sparkles;
            return (
              <div
                key={step.number}
                data-testid={`process-step-${i}`}
                className="relative group"
              >
                <div className="card-modern p-7 lg:p-8 h-full flex flex-col">
                  <div className="flex items-center justify-between mb-6">
                    <div className="relative">
                      <span className="font-serif text-7xl text-gold/20 leading-none select-none">
                        {step.number}
                      </span>
                      <Icon
                        size={22}
                        strokeWidth={1.6}
                        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-sage"
                      />
                    </div>
                    <span className="text-[10px] uppercase tracking-[0.25em] font-semibold text-sage">
                      Étape
                    </span>
                  </div>
                  <h3 className="font-serif text-2xl text-ink mb-3 leading-tight">
                    {step.title}
                  </h3>
                  <p className="font-sans text-sm text-ink/65 leading-relaxed flex-1">
                    {step.text}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;
